/**
 * Checkout settings API client (BFF: `/api/v1/store/settings/checkout`).
 */
import { apiClient } from '@/shared/api';
import type { CheckoutSettings, UpdateCheckoutSettingsRequest } from '../model/settingsTypes';

const BASE = '/api/v1/store/settings/checkout';

export const getCheckoutSettings = async (): Promise<CheckoutSettings> =>
  (await apiClient.get<CheckoutSettings>(BASE)).data;

export const updateCheckoutSettings = async (
  body: UpdateCheckoutSettingsRequest,
): Promise<CheckoutSettings> => (await apiClient.put<CheckoutSettings>(BASE, body)).data;
